/* jshint esversion: 9 */
/**
 * reserve-record-controller :

 *
 *
 */

import { generate } from '@/utils/request';
const config = {
  prefix: '/stock/v1/{organizationId}',
  items: [
    // 出库通知单列表
    { key: 'getOutboundDelivery', url: '/outbound/delivery/order/page', method: 'POST' },
    // 出库通知单详情
    {
      key: 'getOutboundDeliveryDetail',
      url: '/outbound/delivery/order/detail/{id}',
      method: 'GET',
    },
    // 出库通知单商品信息分页
    {
      key: 'getOutboundDeliveryDetailPage',
      url: '/outbound/delivery/order/detail/page',
      method: 'POST',
    },
    // 统计出库通知单发货及已发货数量
    {
      key: 'getOutboundDeliveryDetailStats',
      url: '/outbound/delivery/order/detail/stats/',
      method: 'POST',
      type: 'query',
    },
    // 出库结果单分页
    {
      key: 'getResultRecordsPage',
      url: '/result-records/page',
      method: 'POST',
    },
    // 出库结果单详情
    {
      key: 'getResultRecordsDetail',
      url: '/result-records/{id}',
      method: 'GET',
    },
    // 出库结果单商品信息分页
    {
      key: 'getResultDetailPage',
      url: '/result-detail/page',
      method: 'POST',
    },
    // 统计出库通知单发货及已发货数量
    {
      key: 'getResultDetailStatus',
      url: '/result-detail/stats/{resultId}',
      method: 'GET',
    },
    // 出库通知单发货
    {
      key: 'sendResultRecords',
      url: '/result-records/send-stock',
      method: 'POST',
    },
    // 打单发货列表
    {
      key: 'getOutboundDeliveryOrderWaybillsPage',
      url: '/outbound-delivery-order-waybills/page',
      method: 'POST',
    },
    // 批量发货
    {
      key: 'batchSendStockToOutboundDeliveryOrderWaybills',
      url: '/outbound-delivery-order-waybills/batch-send-stock',
      method: 'POST',
    },
    // 获取物流单号
    {
      key: 'getLogisticsNoToOutboundDeliveryOrderWaybills',
      url: '/outbound-delivery-order-waybills/get-logistics-no',
      method: 'POST',
    },
    // 打印面单
    {
      key: 'printToOutboundDeliveryOrderWaybills',
      url: '/outbound-delivery-order-waybills/print-waybill',
      method: 'POST',
      loadingHide: true,
    },
    // 修改打印状态
    {
      key: 'getPrintStatusDeliveryOrderWaybills',
      url: '/outbound-delivery-order-waybills/print-status',
      method: 'POST',
    },
    // 根据单号，获取详情信息
    {
      key: 'getDeliveryOrderWaybillsDetail',
      url: '/outbound-delivery-order-waybills/detail',
      method: 'GET',
    },
  ],
};
export default {
  ...generate(config),
};
